import { Box, Collapse, Grid, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getDrugAmountOfUseOptions,
  getDrugHowToUseOptions,
  getDrugUseTimeOptions,
  getListOfAdvices,
  postAdvice,
  postAdvice1,
  searchForDrugByName,
} from "../../../../api/area";
import DownArrow from "../../../../assets/SVG/downArrow";
import PlusInage from "../../../../assets/SVG/plusInage";
import CustomizedHook from "../../../project/autocomplatePro";
import { InputCreateProject } from "../../../project/createProjectPop";
import BookmarkDrugs from "./bookmarkDrugs";
import TableUserDrug from "./tableUserDrug";
import { Loader } from "@/components/loader";

export default function DrugInParvande({ parvande, moduleId, areaId }) {
  const [collapseAz, setCollapseAz] = useState();
  const [optionDrugTime, setOptionDrugTime] = useState();
  const [optionUseDrug, setOptionUseDrug] = useState();
  const [optionCountUseDrug, setOptionCountUseDrug] = useState();
  const [areaDrugId, setAreaDrugId] = useState();
  const [drugName, setDrugName] = useState();
  const [dataTable, setDataTable] = useState(undefined);
  const [searchDrugName, setSearchDrugName] = useState("");
  const [modalBookmarkDrugs, setModalBookmarkDrugs] = useState();
  const [data, setData] = useState({
    amount: 0,
    amountOfUse: "",
    howToUse: "",
    useTime: "",
    description: "",
  });
  const [params] = useSearchParams();
  const [patientId] = useMemo(() => {
    return [params.get("patientId")];
  }, [params]);

  const fetchDrugOptions = useCallback(() => {
    if (localStorage.getItem("drug_options") === null) {
      Promise.all([
        getDrugUseTimeOptions(),
        getDrugHowToUseOptions(),
        getDrugAmountOfUseOptions(),
      ]).then((res) => {
        if (res[0]) setOptionDrugTime(res[0]);
        if (res[1]) setOptionUseDrug(res[1]);
        if (res[2]) setOptionCountUseDrug(res[2]);
        localStorage.setItem(
          "drug_options",
          JSON.stringify({
            time: res[0],
            howToUse: res[1],
            amount: res[2],
          }),
        );
      });
    } else {
      const options = JSON.parse(localStorage.getItem("drug_options"));
      setOptionDrugTime(options.time);
      setOptionUseDrug(options.howToUse);
      setOptionCountUseDrug(options.amount);
    }
  }, [localStorage]);

  useEffect(() => {
    if (collapseAz) {
      fetchDrugOptions();
    }
  }, [collapseAz, areaId]);

  const fetchDrugs = useCallback(() => {
    if (dataTable) return;
    getListOfAdvices(areaId, `&patientId=${patientId}`)
      .then((x) => {
        setDataTable(x.content[0].drugs);
      })
      .catch(() => {});
  }, [areaId, collapseAz, dataTable]);

  useEffect(() => {
    if (areaId && collapseAz) {
      fetchDrugs();
    }
  }, [areaId, collapseAz]);

  const [results, setResults] = useState();
  const [searching, setSearching] = useState(false);
  const [selectedDrug, setSelectedDrug] = useState();

  const searchForDrug = useCallback(() => {
    setSearching(true);
    searchForDrugByName(areaId, searchDrugName)
      .then((res) => {
        setResults(res);
      })
      .finally(() => setSearching(false));
  }, [searchDrugName]);

  useEffect(() => {
    if (searchDrugName?.length > 2) {
      searchForDrug();
    }
  }, [searchDrugName]);

  const resultPaneRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        resultPaneRef.current &&
        !resultPaneRef.current.contains(event.target)
      ) {
        setResults(undefined);
        setSearchDrugName("");
      }
    };

    if (results || searching) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [results]);

  return (
    <>
      <BookmarkDrugs
        open={modalBookmarkDrugs}
        setOpen={setModalBookmarkDrugs}
        areaId={areaId}
        parvandeh
        setRowData={setDataTable}
        rowData={dataTable}
        moduleId={moduleId}
        setDataTable={setDataTable}
      />
      <Box
        height={"80vh"}
        sx={{
          overflow: "auto",
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {parvande && (
          <Typography
            sx={{ cursor: "pointer" }}
            mt="20px"
            fontWeight="bold"
            color={"var(--emr-darkblue)"}
          >
            {"داروهای دریافتی"}
          </Typography>
        )}
        <Box
          onClick={() => setCollapseAz(!collapseAz)}
          bgcolor="#EFF1F7"
          borderRadius={"7px"}
          p="10px"
          display="flex"
          justifyContent={"space-between"}
          alignItems="center"
          mt="20px"
          sx={{ cursor: "pointer" }}
        >
          <Typography color="var(--emr-darkblue)">
            {"اطلاعات نسخه دارو"}
          </Typography>
          <DownArrow transform={collapseAz} />
        </Box>
        <Collapse in={collapseAz} timeout="auto">
          <Box mt="-5px" bgcolor="#EFF1F7" p="20px">
            <Box display={"flex"} gap="30px 10px" flexWrap={"wrap"}>
              <Box
                width={"205px"}
                mt="20px"
                borderRadius={"11px"}
                gap="10px"
                bgcolor="#42C3CF"
                display={"flex"}
                alignItems="center"
                p="5px 10px"
                onClick={() => setModalBookmarkDrugs(!modalBookmarkDrugs)}
                sx={{ cursor: "pointer" }}
              >
                <PlusInage />
                <Typography color="white">{"مشاهده داروهای منتخب"}</Typography>
              </Box>
              <Grid
                display={"flex"}
                justifyContent={"center"}
                alignContent={"center"}
                alignItems={"center"}
                width={"225px"}
                sx={{ position: "relative", margin: "0 10px" }}
              >
                <InputCreateProject
                  width={"225px"}
                  sx={{ alignItems: "end", padding: "10px" }}
                  onChange={(e) => {
                    setAreaDrugId(undefined);
                    setDrugName(undefined);
                    setSearchDrugName(e.target.value);
                  }}
                  placeholder={"نام دارو را بنوسید"}
                  label="نام دارو"
                  value={searchDrugName || drugName}
                  justifyContent={"center"}
                  alignItems={"center"}
                />
                {(results || searching) && (
                  <Grid
                    ref={resultPaneRef}
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"10px"}
                    sx={{
                      position: "absolute",
                      width: "calc(100% + 200px)",
                      height: "140px",
                      maxHeight: "140px",
                      overflow: "auto",
                      backgroundColor: "white",
                      zIndex: 99,
                      border: "1px solid black",
                      borderRadius: "8px",
                      top: "70px",
                    }}
                  >
                    {searching && <Loader />}
                    {!searching && results && results.length === 0 && (
                      <Typography sx={{ margin: "20px auto" }}>
                        موردی یافت نشد
                      </Typography>
                    )}
                    {results &&
                      results.map((e, index) => (
                        <Typography
                          sx={{
                            borderBottom: "1px solid gray",
                            cursor: "pointer",
                            fontSize: "0.7rem",
                            textAlign: "right",
                            padding: "5px",
                          }}
                          color={"black"}
                          key={index}
                          onClick={() => {
                            setResults(undefined);
                            setAreaDrugId(e.id);
                            setDrugName(e.drugInfo.name);
                            setSearchDrugName(undefined);
                            setSelectedDrug(e);
                          }}
                        >
                          {`نام دارو: ${e.drugInfo.name} - دُز: ${e.drugInfo.dose} - تعداد باقی مانده در اردو:  ${e.reminder}`}
                        </Typography>
                      ))}
                  </Grid>
                )}
              </Grid>
              <InputCreateProject
                width={"200px"}
                placeholder={"تعداد دارو را بنوسید"}
                label="تعداد دارو"
                onChange={(e) => {
                  setData({ ...data, amount: e.target.value });
                }}
              />
              <Box width={"225px"}>
                <CustomizedHook
                  width={"225px"}
                  placeholder={"مقدار مصرف را بنوسید"}
                  label="مقدار مصرف"
                  options={optionCountUseDrug}
                  onChange={(e, newValue) => {
                    setData({ ...data, amountOfUse: newValue.key });
                  }}
                />
              </Box>
              <Box width={"225px"}>
                <CustomizedHook
                  width={"225px"}
                  placeholder={"طریقه مصرف را بنوسید"}
                  label="طریقه مصرف"
                  options={optionUseDrug}
                  onChange={(e, newValue) => {
                    setData({ ...data, howToUse: newValue.key });
                  }}
                />
              </Box>
              <Box width={"200px"}>
                <CustomizedHook
                  width={"225px"}
                  placeholder={"زمان مصرف را بنوسید"}
                  label="زمان مصرف"
                  options={optionDrugTime}
                  onChange={(e, newValue) => {
                    setData({ ...data, useTime: newValue.key });
                  }}
                  // value={
                  //   states.find((state) => state.name === stepOne.state) ||
                  //   dataLoc?.states ||
                  //   null
                  // }
                />
              </Box>
            </Box>
            <Box mt="30px" display={"flex"} justifyContent="end">
              <botton
                style={{
                  border: "none",
                  backgroundColor: "var(--emr-darkblue)",
                  color: "white",
                  padding: "5px 40px",
                  borderRadius: "10px",
                  marginLeft: "20px",
                  cursor: "pointer",
                  zIndex: "1",
                  // height: "30px",
                }}
                onClick={() => {
                  if (!areaDrugId || !selectedDrug) {
                    toast.error("لطفا دارو را انتخاب نمایید");
                    return;
                  }

                  if (data.amount > selectedDrug.reminder) {
                    toast.error(
                      `تعداد باقی مانده از دارو مدنظر ${selectedDrug.reminder} می باشد`,
                    );
                    return;
                  }
                  if (moduleId) {
                    postAdvice(patientId, moduleId, areaDrugId, data)
                      .then((x) => {
                        // setDataTable([
                        //   ...dataTable,
                        //   {
                        //     amountOfUseFa: data?.amountOfUse,
                        //     drugName: areaDrugId?.value,
                        //     howToUseFa: data?.howToUse,
                        //     useTimeFa: data?.useTime,
                        //     suggestCount: Number(data?.amount),
                        //   },
                        // ]);
                        getListOfAdvices(areaId, `&patientId=${patientId}`)
                          .then((z) => setDataTable(z[0].drugs))
                          .catch((z) => {});
                        toast.success("ثبت شد");
                      })
                      .catch((z) => {
                        toast.error(z?.data?.msg);
                      });
                  } else {
                    postAdvice1(
                      patientId,
                      // moduleId,
                      areaDrugId,
                      data,
                    )
                      .then((x) => {
                        // setDataTable([
                        //   ...dataTable,
                        //   {
                        //     amountOfUseFa: data?.amountOfUse,
                        //     drugName: areaDrugId?.value,
                        //     howToUseFa: data?.howToUse,
                        //     useTimeFa: data?.useTime,
                        //     suggestCount: Number(data?.amount),
                        //   },
                        // ]);
                        getListOfAdvices(areaId, `&patientId=${patientId}`)
                          .then((z) => setDataTable(z[0].drugs))
                          .catch(() => {});
                        toast.success("ثبت شد");
                      })
                      .catch((z) => {
                        toast.error(z?.data?.msg);
                      });
                  }
                }}
              >
                ثبت
              </botton>
            </Box>
            {dataTable?.length > 0 && (
              <TableUserDrug
                areaId={areaId}
                parvandeh
                moduleId={moduleId}
                setRowData={setDataTable}
                rowData={dataTable}
              />
            )}
          </Box>
        </Collapse>
      </Box>
    </>
  );
}
